// import Clocking from './Clocking';

export default {
  priority: 97,
  name: app.translate("بررسی تردد"),
  path: "clocking-check",
  permissions: [
    "MapConsoleMenu/CheckClockingMenu",
    "e3cd1de3cd1df6c98c282f012e93b1f40d5ca546a822a747b9fef9cfd38d021b5bdcc1f6c98c282f012e93b1f40d5ca546a822a747b9fef9cfd38d021b5bdcc1"
  ],
  // component: Clocking,
  component: load(() =>
    import(/* webpackChunkName: "Clocking" */ "./Clocking")
  ),
  icon: "swap-vertical",
  drawer: true,
  description: `بررسی تردد: در صورت استفاده از ماژول موقعیت جغرافیایی، تردد هایی که از طریق تلفن همراه افراد ثبت شده باشد را میتوانید در این قسمت مشاهده کنید. لازم به ذکر است با توجه به اینکه پرسنل در زمان ثبت تردد از طریق اپلیکیشن موبایل نیاز به گرفتن عکس سلفی از خود دارند، میتوانید تصاویر مربوط به هر تردد را در این قسمت به وضوح مشاهده کنید.`,
};
